import { render, staticRenderFns } from "./cargosDrawer.vue?vue&type=template&id=4af3334a&"
import script from "./cargosDrawer.vue?vue&type=script&lang=js&"
export * from "./cargosDrawer.vue?vue&type=script&lang=js&"
import style0 from "./cargosDrawer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports